import { routes as notificationRoutes } from './notification'
import { routes as notificationPreferenceRoutes } from './notification-preference'

export const routes = {
  ...notificationPreferenceRoutes,
  ...notificationRoutes,
}
